import { Row, Col, Space } from 'antd'
import dayjs from 'dayjs'

import _filter from 'lodash/filter'
import _find from 'lodash/find'
import _isEmpty from 'lodash/isEmpty'
import _map from 'lodash/map'
import _includes from 'lodash/includes'

import Title from 'components/Title'
import Span from 'components/Span'
import Tag from 'components/Tag'
import Breadcrumb from 'components/Breadcrumb'
import Link from 'components/Link'

import asyncComponent from 'utils/asyncComponent'

import Styled from './styled'

const ArticleRecommend = asyncComponent(() => import('components/ArticleRecommend'))
const ArticleRelated = asyncComponent(() => import('components/ArticleRelated'))
const AffixArticleCategories = asyncComponent(() =>
  import('components/Affix/AffixArticleCategories')
)

export default function ArticleDetail({ data, slug }) {
  const relatedArticles = data?.relatedArticles
  const publishedAt = data?.updatedAt
  const title = data?.title
  const articleSlug = data?.code
  const content = data?.content
  const articleCategories = _filter(
    data?.articleTypes,
    item => !_includes(['portfolio', 'popular'], item?.code)
  )
  const category = _find(data?.articleTypes, ['code', slug])
  const categorySlug = category?.code
  const categoryName = category?.name

  return (
    <Styled>
      <AffixArticleCategories tab={categorySlug} />

      <div className="breadcrumb-block">
        <div className="container">
          <Breadcrumb
            items={[
              { label: 'หน้าหลัก', link: '/' },
              { label: 'บทความ', link: '/blog' },
              { label: categoryName, link: `/blog/${categorySlug}` },
              {
                label: title,
                link: `/blog/${categorySlug}/${articleSlug}`,
              },
            ]}
          />
        </div>
      </div>

      <div className="container">
        <Row
          gutter={[
            { xs: 0, sm: 0, md: 0, lg: 50 },
            { xs: 0, sm: 0, md: 0, lg: 50 },
          ]}
        >
          <Col span={24} lg={17}>
            <div className="content">
              <div className="title-block">
                <Title level={1} className="title">
                  {title}
                </Title>
              </div>

              <div className="categories-block">
                <Space size={5} wrap>
                  {_map(articleCategories, (item, index) => {
                    const title = item?.name
                    const slug = item?.code
                    const link = `/blog/${slug}`

                    return (
                      <Link href={link} key={index}>
                        <Tag>
                          <Span className="text-tag">{title}</Span>
                        </Tag>
                      </Link>
                    )
                  })}
                </Space>

                {publishedAt && (
                  <div className="date-block">
                    <Span className="text-date">{dayjs(publishedAt).format('DD MMMM YYYY')}</Span>
                  </div>
                )}
              </div>

              <div className="content-block">
                <div className="detail-block">
                  <div className="text-detail" dangerouslySetInnerHTML={{ __html: content }} />
                </div>
              </div>
            </div>
          </Col>

          <Col span={24} lg={7}>
            <ArticleRecommend />
          </Col>
        </Row>
      </div>

      {!_isEmpty(relatedArticles) && (
        <div className="relate-block">
          <div className="container">
            <ArticleRelated articles={relatedArticles} categorySlug={categorySlug} />
          </div>
        </div>
      )}
    </Styled>
  )
}
